import React from 'react';
import DatePickerDateStartEnd from "@ui/datePicker/DatePickerDateStartEnd";
import {sx} from './sx'
import {useTranslation} from "react-i18next";
import {Stack, Typography} from "@mui/material";
import TimeSvg from "@resource/svg/TimeSvg";


const DateSelectSideBar = ({
                               dateStart,
                               dateEnd,
                               onChangeDateStart,
                               onChangeDateEnd,
                               disabled = false,
                               hasTime = false,
                               size = 'medium',
                               format = undefined,
                               showLabel=false,
                               children=null
                           }) => {

    const {t} = useTranslation()
    const currentFormat = format ? format : hasTime ? 'DD.MM.YYYY HH:mm' : undefined

    return (

        <Stack
            rowGap={'10px'}
            columnGap={'4px'}
            sx={sx.inner}
            direction={'row'}
            flexWrap={'wrap'}
        >

            {showLabel && <Stack
                gap={'3px'}
                direction={'row'}
                alignItems={'center'}
                sx={sx.innerLabel}
            >
                <TimeSvg/>

                <Typography
                    sx={sx.label}
                >
                    {t('base.timeInterval')}
                </Typography>

            </Stack>}

            <DatePickerDateStartEnd
                label={t('dateStart')}
                value={dateStart}
                size={size}
                dateStart={dateStart}
                onChangeDateStart={onChangeDateStart}
                dateEnd={dateEnd}
                onChangeDateEnd={onChangeDateEnd}
                format={currentFormat}
                disabled={disabled}
                initialTab={0}
                hasTime={hasTime}
            />
            <DatePickerDateStartEnd
                label={t('dateEnd')}
                value={dateEnd}
                size={size}
                dateStart={dateStart}
                onChangeDateStart={onChangeDateStart}
                dateEnd={dateEnd}
                onChangeDateEnd={onChangeDateEnd}
                format={currentFormat}
                disabled={disabled}
                initialTab={1}
                hasTime={hasTime}
            />
            {children && children}
        </Stack>


    );
};

export default DateSelectSideBar;